import { useQuery } from '@tanstack/react-query';
import { osmGet } from '@/api/osmClient';
import type { UserPoiCollection } from '@/types/osm';

interface PoiOpts {
  source?: string;
  category?: string;
  limit?: number;
  enabled?: boolean;
}

export function useOsmPois({ source, category, limit = 20000, enabled = true }: PoiOpts = {}) {
  const query = new URLSearchParams();
  if (source) query.set('source', source);
  if (category) query.set('category', category);
  if (limit) query.set('limit', String(limit));
  const qs = query.toString();
  const path = `/pois/geojson${qs ? `?${qs}` : ''}`;
  return useQuery<UserPoiCollection>({
    queryKey: ['osm', 'pois', source ?? '*', category ?? '*', limit],
    queryFn: () => osmGet<UserPoiCollection>(path),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
